//  src/admin/AdminHeader.js
//
//  Header area per l'area di amministrazione.
//  – Include hamburger menu e logo/titolo cliccabili: il tap/ click (o Enter/Space) ricarica
//    completamente l'app (full refresh) — comportamento ideale per mobile.

import React, { useState } from "react";
import AdminMenu from "./AdminMenu";
import logo from "./logo.png";

/* ===============================================================
   PALETTE
   ============================================================== */
const palette = {
  primaryStart: "#FF8C00",
  primaryEnd:   "#FF6600",
  textLight:    "#fff",
  textDark:     "#000",
};

/* ===============================================================
   COMPONENT
   ============================================================== */
export default function AdminHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleHamburgerClick = () => setMenuOpen(true);
  const handleCloseMenu      = () => setMenuOpen(false);

  /* -------------------------------------------------------------
     RENDER
     ------------------------------------------------------------- */
  return (
    <header style={styles.header}>
      {/* LOGO + TITOLO – cliccabile per full refresh */}
      <div
        style={styles.logoArea}
        role="button"
        tabIndex={0}
        aria-label="Ricarica la pagina"
        onClick={() => window.location.reload()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") window.location.reload();
        }}
      >
        <img src={logo} alt="Risto Buddy" style={styles.logoImage} />
        <span style={styles.logoText}>RISTO&nbsp;BUDDY</span>
      </div>

      {/* HAMBURGER */}
      <button onClick={handleHamburgerClick} style={styles.hamburger}>
        <div style={styles.bar} />
        <div style={styles.bar} />
        <div style={styles.bar} />
      </button>

      {/* MENU LATERALE */}
      <AdminMenu isOpen={menuOpen} onClose={handleCloseMenu} />
    </header>
  );
}

/* ===============================================================
   STYLE (inline JS object)
   ============================================================== */
const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: `linear-gradient(90deg, ${palette.primaryStart} 0%, ${palette.primaryEnd} 100%)`,
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    padding: "10px 16px",
    position: "relative",
    zIndex: 10,
  },

  /* Logo area cliccabile */
  logoArea: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "none",
    WebkitTapHighlightColor: "transparent", // rimuove highlight su Android
    transition: "transform 0.2s",
  },
  logoImage: {
    height: 34,
    marginRight: 10,
  },
  logoText: {
    color: palette.textDark,
    fontWeight: "bold",
    fontSize: 18,
    letterSpacing: 0.5,
  },

  /* Hamburger */
  hamburger: {
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    padding: 8,
    transition: "transform 0.2s",
  },
  bar: {
    width: 22,
    height: 2,
    background: palette.textLight,
    borderRadius: 1,
  },
};
